/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * Option CSS
 */
export const styles = css`
	:host {

	}

  .option {
    padding:  10px 10px 10px 0;
    cursor: pointer;
    background-color:white;
    display: flex;
    align-items: baseline;
  }

  .extra-padding {
    padding:  10px;
  }

  .option:hover {
    background-color: #f4f4f4;
  }

  .check {
    position: absolute;
    right: 8px;
  }

  .label{
    top: -2px;
  }

  .label-container{
    top: -2px;
    position: relative;
    display: flex;
    align-items: baseline;
  }

  .prefix{
    padding: 0 6px;
  }

  /* .options {
    position: absolute;
    z-index: 1;
    top: calc(100% + 2px);
    left: 0;
    width: calc(100% - 22px);
    max-height: 200px;
    overflow-y: auto;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    padding: 10px;
    font-size: 14px;
  } */


`;

export default [styles];
